import axios from "axios";
import { Updater } from "use-immer";

import { useQuery } from "@tanstack/react-query";

import { QueryMeta } from "../../types/react-query";
import { pluginPendingTestKeys } from "../queryKeys";

interface PendingTestResults {
  statusCode: number;
  statusText: string;
}

const getPluginPerformanceTestStatus = async (testId: string) => {
  const resp = await axios.get<PendingTestResults>(
    `https://www.webpagetest.org/testStatus.php?f=json&pos=1&test=${testId}`
  );
  return resp.data;
};

export const usePluginPerformanceTestStatus = (
  testId: string,
  enabled: boolean,
  setEnabled: Updater<boolean>
) => {
  return useQuery<PendingTestResults, Error>({
    queryKey: pluginPendingTestKeys.one(testId),
    queryFn: async () => getPluginPerformanceTestStatus(testId),
    enabled: enabled && !!testId,
    refetchInterval: 5000,
    meta: {
      onSuccess: (data: any) => {
        if (data?.statusCode !== 100) {
          setEnabled(false);
        }
      },
      onError: (error) => {
        if (axios.isAxiosError(error)) {
          if (error.response?.status === 429) {
            // Do nothing
          }
        }
      },
    } as QueryMeta,
  });
};
